import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { Typography } from '@mui/material';

import { FORTA_GRAY2, FORTA_SUCCESS } from '../../utils/colors';
import FHSkeletonLoader from './FHSkeletonLoader';

const SCALE_UNIT = 6;

const scale = [
  { name: `${SCALE_UNIT}%`, value: 100 },
  { name: `${2 * SCALE_UNIT}%`, value: 100 },
  { name: `${3 * SCALE_UNIT}%`, value: 100 },
  { name: `${4 * SCALE_UNIT}%`, value: 100 },
  { name: `${5 * SCALE_UNIT}%`, value: 100 },
  { name: `${6 * SCALE_UNIT}%`, value: 100 },
  { name: `${7 * SCALE_UNIT}%`, value: 100 },
  { name: `${8 * SCALE_UNIT}%`, value: 100 },
  { name: `${9 * SCALE_UNIT}%`, value: 100 },
  { name: `${10 * SCALE_UNIT}%`, value: 100 },
  { name: `${11 * SCALE_UNIT}%`, value: 100 },
  { name: `${12 * SCALE_UNIT}%`, value: 100 },
  { name: `${13 * SCALE_UNIT}%`, value: 100 },
  { name: `${14 * SCALE_UNIT}%`, value: 100 },
  { name: `${15 * SCALE_UNIT}%`, value: 100 },
  { name: `${16 * SCALE_UNIT}%`, value: 100 },
  { name: '100%', value: 100 },
];

interface FHProgressMeterProps {
  chartColor?: string;
  chartHeight?: number;
  chartWidth?: number;
  endAngle?: number;
  startAngle?: number;
  cornerRadius?: number;
  innerRadius?: number;
  outerRadius?: number;
  animate?: boolean;
  paddingAngle?: number;
  valueFontSize?: number;
  dataTestId?: string;
  progressPercentage: number; // 0 to 100
  loading?: boolean;
}

function FHProgressMeter({
  progressPercentage,
  dataTestId,
  chartColor = FORTA_SUCCESS,
  animate = true,
  startAngle = 180,
  endAngle = 0,
  chartWidth = 400,
  chartHeight = 300,
  cornerRadius = 5,
  innerRadius = 90,
  outerRadius = 130,
  paddingAngle = 3,
  valueFontSize = 28,
  loading = false,
}: FHProgressMeterProps) {
  const progress = loading
    ? 0
    : progressPercentage > 100
      ? 100
      : progressPercentage < 0
        ? 0
        : progressPercentage;
  const numUnits = progress / SCALE_UNIT;

  const data: { name: string; value: number }[] = [];

  scale.forEach((s, i) => {
    if (i < numUnits) {
      data.push(s);
    }
  });

  return (
    <>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart
          width={chartWidth}
          height={chartHeight}
          data-testid={dataTestId ?? 'progressMeter'}
        >
          <Pie
            data={scale}
            startAngle={startAngle}
            endAngle={endAngle}
            cornerRadius={cornerRadius}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            fill={FORTA_GRAY2}
            paddingAngle={paddingAngle}
            dataKey="value"
            isAnimationActive={animate}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={chartColor} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <Typography
        fontSize={valueFontSize}
        sx={{ mt: `-${chartHeight / 1.7}px`, display: 'flex', justifyContent: 'center' }}
      >
        {loading ? <FHSkeletonLoader width={40} height={40} /> : `${progress}%`}
      </Typography>
    </>
  );
}

export default FHProgressMeter;
